import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { saveAs } from 'file-saver';
import { AdobeService } from 'src/app/services/adobe.service';
import { ContextService } from 'src/app/services/context.service';
import { ProcoreService } from 'src/app/services/procore.service';

@Component({
	selector: 'app-message',
	templateUrl: './message.component.html',
	styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
	@Output() emitRequestCancelled = new EventEmitter<any>();
	@Input() signatureObject: any;
	@Input() expanded: boolean;

	loadingCancelRequest = false;
	loadingSendReminder = false;
	loadingContinueRequest = false;

	// signature: any;
	// participants: any;

	constructor(
		private adobeService: AdobeService,
		private contextService: ContextService,
		private procoreService: ProcoreService
	) { }

	ngOnInit() { }

	cancelRequest(signature) {
		this.loadingCancelRequest = true;
		this.adobeService.cancelRequest(this.contextService.procoreContextObject.context.company_id, this.signatureObject.clientSignature.signatureRequestId, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe((response) => {
				if (response == true) {
					this.emitRequestCancelled.emit(this.signatureObject);
				} else {
					// TODO: Show an error?
				}
				this.loadingCancelRequest = false;
			});
	}

	sendReminder(signature) {

	}

	downloadRequest() {
		this.adobeService.downloadAdobeAgreementDocument(this.signatureObject.clientSignature.signatureRequestId, this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email)
			.subscribe((result) => {
				console.log(result);
				saveAs(result, "file.pdf");
			});
	}

	viewRequest() {
		this.loadingCancelRequest = true;
		this.adobeService.getAdobeAuthoringAgreement(this.signatureObject.clientSignature.signatureRequestId, this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email)
			.subscribe((result) => {
				// if (response == true) {
				// 	//this.emitRequestCancelled.emit(this.signatureObject);
				// } else {
				// 	// TODO: Show an error?
				// }

				window.open(result, '_blank');

				this.loadingCancelRequest = false;
			});
	}

	continueRequest() {
		this.loadingCancelRequest = true;
		this.adobeService.getAdobeAuthoringAgreementDraft(this.signatureObject.clientSignature.signatureRequestId, this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email)
			.subscribe((result) => {
				// if (response == true) {
				// 	//this.emitRequestCancelled.emit(this.signatureObject);
				// } else {
				// 	// TODO: Show an error?
				// }

				window.open(result, '_blank');

				this.loadingCancelRequest = false;
			});
	}
}

